import { render, staticRenderFns } from "./CiPublicationTable.vue?vue&type=template&id=5f18ab93&"
import script from "./CiPublicationTable.vue?vue&type=script&lang=js&"
export * from "./CiPublicationTable.vue?vue&type=script&lang=js&"
import style0 from "./CiPublicationTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports